import { Navigate, useParams } from "react-router-dom";
import { useKarunaLink } from "@/project/karuna/utils/navigationRoutes";

/**
 * Legacy route: /school/submit/:id — opens the submission modal on the activities list.
 */
const SchoolEventSubmission = () => {
  const { id } = useParams<{ id: string }>();
  const getLink = useKarunaLink();
  const target = `${getLink("/school/activities")}?submit=${encodeURIComponent(id ?? "")}`;
  return <Navigate to={target} replace />;
};

export default SchoolEventSubmission;
